import { render, staticRenderFns } from "./AppFooterCategory.vue?vue&type=template&id=b6264bc4&"
import script from "./AppFooterCategory.vue?vue&type=script&lang=js&"
export * from "./AppFooterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports